
const state = {
    urlFilters: {} //-- filters passed from the url as query strings
}

const mutations = {
    SET_FILTERS_FROM_URL(state, data) {
        state.urlFilters = data;
    }
}

const actions = {
    setFiltersFromUrl({ commit }, data) {
        commit('SET_FILTERS_FROM_URL', data);
    }
}

export default {
    namespaced: true,
    state,
    actions,
    mutations
}
